export default __webpack_public_path__ + "static/media/automotive.da8e4711.jpg";